// Social Links Configuration
// Edit these URLs directly to update your social media links

export const socialLinks = {
    github: 'https://github.com/rabiaryal',
    linkedin: 'https://www.linkedin.com/in/rabi-a-992715283',
    instagram: 'https://www.instagram.com/rabiaryal_/'
};

// You can add more social platforms here:
// twitter: 'https://twitter.com/yourusername',
// youtube: 'https://youtube.com/yourchannel',
// portfolio: 'https://yourportfolio.com'